import type { QueryClientConfig } from "@tanstack/vue-query";

import { shouldRetryRequest, shouldThrowToErrorBoundary } from "@/lib/error-reporting.ts";

export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      retry: shouldRetryRequest,
      throwOnError: shouldThrowToErrorBoundary,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      retry: false,
      throwOnError: shouldThrowToErrorBoundary,
    },
  },
};
